import { Icon } from '@/new/components/icon';

interface AttemptedSummaryProps {
  attempted: number;
  successful: number;
  failed: number;
  attemptedLabel?: string;
  successLabel?: string;
  failedLabel?: string;
}

export function AttemptedSummary({
  attempted,
  successful,
  failed,
  attemptedLabel = 'attempted',
  successLabel = 'successful',
  failedLabel = 'failed',
}: AttemptedSummaryProps) {
  return (
    <div className="flex items-center gap-2 text-xs">
      <div className="flex items-center gap-1.5 rounded-md bg-blue-50 px-2 py-1">
        <span className="h-1.5 w-1.5 rounded-full bg-blue-600" />
        <span className="text-blue-700">
          <span className="font-medium text-blue-900">{attempted.toLocaleString()}</span> {attemptedLabel}
        </span>
      </div>
      <Icon className="lucide--arrow-right h-3 w-3 text-gray-300" />
      <div className="flex items-center overflow-hidden rounded-md">
        <div className="flex items-center gap-1.5 bg-green-50 px-2 py-1">
          <span className="h-1.5 w-1.5 rounded-full bg-green-600" />
          <span className="text-green-700">
            <span className="font-medium text-green-900">{successful.toLocaleString()}</span> {successLabel}
          </span>
        </div>
        <div className="flex items-center gap-1.5 bg-amber-50 px-2 py-1">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-600" />
          <span className="text-amber-700">
            <span className="font-medium text-amber-900">{failed.toLocaleString()}</span> {failedLabel}
          </span>
        </div>
      </div>
    </div>
  );
}
